import { ErrorHandler } from 'components/errors/ErrorHandler';
import _ from 'lodash';
import { PropsWithChildren, isValidElement, useMemo } from 'react';

import { WidgetSkeleton } from './WidgetSkeleton';

interface IWidgetWrapperProps {
  readonly colSpan?: 1 | 2 | 4;
  readonly className?: string;
  readonly isLoading?: boolean;
  readonly error?: Error | unknown;
  readonly errorContent?: React.ReactNode;
}

export function WidgetWrapper({
  colSpan = 1,
  className = '',
  children,
  error,
  isLoading = false,
  errorContent = <ErrorHandler err={error} />
}: PropsWithChildren<IWidgetWrapperProps>) {
  const renderContent = useMemo(() => {
    if (error) {
      return <div className="w-full">{errorContent}</div>;
    }

    if (isLoading) {
      return (
        <div className="h-full w-full">
          <WidgetSkeleton />
        </div>
      );
    }

    if (isValidElement(children)) return children;
  }, [children, error, isLoading, errorContent]);

  if (_.isUndefined(renderContent)) return null;

  return (
    <div
      className={`${
        colSpan === 4
          ? 'col-span-4'
          : colSpan === 2
          ? 'col-span-2'
          : 'col-span-1'
      } ${className}`}
    >
      {renderContent}
    </div>
  );
}
